/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, PropertySeeker } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreatePropertySeeker(options?: Omit<(UseMutationOptions<(PropertySeeker | undefined), DefaultError, Prisma.PropertySeekerCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerCreateArgs, DefaultError, PropertySeeker, true>('PropertySeeker', 'POST', `${endpoint}/propertySeeker/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyPropertySeeker(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.PropertySeekerCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('PropertySeeker', 'POST', `${endpoint}/propertySeeker/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyPropertySeeker<TArgs extends Prisma.PropertySeekerFindManyArgs, TQueryFnData = Array<Prisma.PropertySeekerGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findMany`, args, options, fetch);
}

export function useInfiniteFindManyPropertySeeker<TArgs extends Prisma.PropertySeekerFindManyArgs, TQueryFnData = Array<Prisma.PropertySeekerGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findMany`, args, options, fetch);
}

export function useSuspenseFindManyPropertySeeker<TArgs extends Prisma.PropertySeekerFindManyArgs, TQueryFnData = Array<Prisma.PropertySeekerGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyPropertySeeker<TArgs extends Prisma.PropertySeekerFindManyArgs, TQueryFnData = Array<Prisma.PropertySeekerGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findMany`, args, options, fetch);
}

export function useFindUniquePropertySeeker<TArgs extends Prisma.PropertySeekerFindUniqueArgs, TQueryFnData = Prisma.PropertySeekerGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniquePropertySeeker<TArgs extends Prisma.PropertySeekerFindUniqueArgs, TQueryFnData = Prisma.PropertySeekerGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findUnique`, args, options, fetch);
}

export function useFindFirstPropertySeeker<TArgs extends Prisma.PropertySeekerFindFirstArgs, TQueryFnData = Prisma.PropertySeekerGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstPropertySeeker<TArgs extends Prisma.PropertySeekerFindFirstArgs, TQueryFnData = Prisma.PropertySeekerGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/findFirst`, args, options, fetch);
}

export function useUpdatePropertySeeker(options?: Omit<(UseMutationOptions<(PropertySeeker | undefined), DefaultError, Prisma.PropertySeekerUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerUpdateArgs, DefaultError, PropertySeeker, true>('PropertySeeker', 'PUT', `${endpoint}/propertySeeker/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyPropertySeeker(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.PropertySeekerUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('PropertySeeker', 'PUT', `${endpoint}/propertySeeker/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertPropertySeeker(options?: Omit<(UseMutationOptions<(PropertySeeker | undefined), DefaultError, Prisma.PropertySeekerUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerUpsertArgs, DefaultError, PropertySeeker, true>('PropertySeeker', 'POST', `${endpoint}/propertySeeker/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeletePropertySeeker(options?: Omit<(UseMutationOptions<(PropertySeeker | undefined), DefaultError, Prisma.PropertySeekerDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerDeleteArgs, DefaultError, PropertySeeker, true>('PropertySeeker', 'DELETE', `${endpoint}/propertySeeker/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, PropertySeeker, Prisma.PropertySeekerGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyPropertySeeker(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.PropertySeekerDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.PropertySeekerDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('PropertySeeker', 'DELETE', `${endpoint}/propertySeeker/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.PropertySeekerDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.PropertySeekerDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.PropertySeekerDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregatePropertySeeker<TArgs extends Prisma.PropertySeekerAggregateArgs, TQueryFnData = Prisma.GetPropertySeekerAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/aggregate`, args, options, fetch);
}

export function useSuspenseAggregatePropertySeeker<TArgs extends Prisma.PropertySeekerAggregateArgs, TQueryFnData = Prisma.GetPropertySeekerAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/aggregate`, args, options, fetch);
}

export function useGroupByPropertySeeker<TArgs extends Prisma.PropertySeekerGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.PropertySeekerGroupByArgs['orderBy'] } : { orderBy?: Prisma.PropertySeekerGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.PropertySeekerGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.PropertySeekerGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.PropertySeekerGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.PropertySeekerGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.PropertySeekerGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByPropertySeeker<TArgs extends Prisma.PropertySeekerGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.PropertySeekerGroupByArgs['orderBy'] } : { orderBy?: Prisma.PropertySeekerGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.PropertySeekerGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.PropertySeekerGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.PropertySeekerGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.PropertySeekerGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.PropertySeekerGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/groupBy`, args, options, fetch);
}

export function useCountPropertySeeker<TArgs extends Prisma.PropertySeekerCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.PropertySeekerCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/count`, args, options, fetch);
}

export function useSuspenseCountPropertySeeker<TArgs extends Prisma.PropertySeekerCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.PropertySeekerCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.PropertySeekerCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('PropertySeeker', `${endpoint}/propertySeeker/count`, args, options, fetch);
}
import type { CreditScoreRange, AnnualIncome, MostRecentEviction } from '.zenstack/models';

export function useCheckPropertySeeker<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; creditScoreRange?: CreditScoreRange; annualIncome?: AnnualIncome; mostRecentEviction?: MostRecentEviction }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('PropertySeeker', `${endpoint}/propertySeeker/check`, args, options, fetch);
}
